// extracted by mini-css-extract-plugin
export default {"circularLoader--legacy":"CircularLoader_circularLoader--legacy__n5ctf"};